import { render, staticRenderFns } from "./root-pogs-submissions.vue?vue&type=template&id=2d6eb078&scoped=true&"
import script from "./root-pogs-submissions.vue?vue&type=script&lang=js&"
export * from "./root-pogs-submissions.vue?vue&type=script&lang=js&"
import style0 from "./root-pogs-submissions.vue?vue&type=style&index=0&id=2d6eb078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6eb078",
  null
  
)

export default component.exports